angular.module('appMarketplace')
    .service('FormattingService', [function () {
        var service = this;

        service.getNumberView = function (value) {
            if (!value) {
                return '';
            }

            var parts = value.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        };

        service.getPriceView = function (currencySymbol, value) {
            var qualifier = value < 0 ? '-' : '';
            var modValue = Math.abs(value).toFixed(2);
            var currency = currencySymbol ? currencySymbol : '';

            return qualifier + currency + service.getNumberView(modValue);
        };

        service.countDecimals = function (num) {
            var numStr = String(num);
            var pointIdx = numStr.lastIndexOf(".");
            return (pointIdx === -1) ? 0
                                     : numStr.substr(pointIdx + 1).length;
        };

        service.isNumber = function (n) {
            return typeof n === 'number' && !isNaN(n);
        };

        service.formatQuantity = function (qty) {
            if (typeof qty === 'string') {
                qty = parseFloat(qty);
            }
            if (!service.isNumber(qty)) {
                qty = 0;
            }
            var numberOfDecimals = service.countDecimals(qty);
            return (numberOfDecimals === 0) ? "" + qty
                                            : qty.toFixed(2);
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/formatting-service.js
// module id = 9
// module chunks = 37